import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  text-align: center;
  margin: ${spacing(0, 1)};
  position: relative;
`
export const button = css`
  display: inline-flex;
`
